<template>
	<div class="fixed">
		<h1 style="text-align: center;margin-bottom: 10px">成都市消毒协会理事、监事名单</h1>
		<el-table border :data="data">
			<el-table-column width="55" align="center" label="序号" type="index"></el-table-column>
			<el-table-column align="center" label="单位名称" prop="userName"></el-table-column>
			<el-table-column align="center" label="会员级别" prop="membersGrade"></el-table-column>

		</el-table>
	</div>
</template>

<script>
export default {
	name: "memberList",
	data(){
		return {
			data:[]
		}
	},
	mounted() {
		this.getList()
	},
	methods:{
		getList:function(){
			this.$axios.get('/websiteOpenApi/getMemberList').then(res => {
				this.data = JSON.parse(res.data.msg)
			})
		}
	}
}
</script>

<style scoped>
	.fixed {
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		background-color: #fff;
		z-index: 99999;
		overflow: auto;
	}
</style>
